<!-- src/components/TwelveStepProcess.vue -->
<template>
  <div class="twelve-step-process">
    <!-- Banner Section with Image -->
    <section class="banner">
      <img src="../assets/12step.jpg" alt="Recovery banner" />
    </section>

    <header>
      <h1>The 12-Step Recovery Process</h1>
      <p>An overview of the 12-Step approach to overcoming addiction and finding support.</p>
    </header>

    <section class="section">
      <h2>What is the 12-Step Program?</h2>
      <p>
        The 12-Step program is a structured approach to recovery that was originally developed
        by Alcoholics Anonymous (AA). It is based on twelve guiding principles that help individuals
        confront their addiction, build accountability, and cultivate a supportive community.
      </p>
    </section>

    <section class="section">
      <h2>The Core Steps</h2>
      <p>The program involves twelve fundamental steps, which are generally followed in order:</p>
      <ol>
        <li>Admitting powerlessness over addiction.</li>
        <li>Believing in a higher power to help restore sanity.</li>
        <li>Deciding to turn control over to that higher power.</li>
        <li>Self-examining and taking personal inventory.</li>
        <li>Admitting wrongs to oneself, the higher power, and others.</li>
        <li>Being ready to have character defects removed.</li>
        <li>Asking the higher power to remove those shortcomings.</li>
        <li>Listing people harmed by addiction and seeking to make amends.</li>
        <li>Directly making amends, where possible, except when it would harm others.</li>
        <li>Continuing self-reflection and admitting when wrong.</li>
        <li>Seeking to improve connection with the higher power through prayer and meditation.</li>
        <li>Carrying the message of recovery to others and practicing these principles daily.</li>
      </ol>
    </section>

    <section class="section">
      <h2>Benefits of the 12-Step Process</h2>
      <p>
        The 12-Step program offers a supportive structure for personal growth and recovery. It promotes
        accountability, builds self-awareness, and connects individuals with a community that shares
        similar goals. The process encourages lasting changes in mindset and behavior, making it a
        widely respected approach to recovery.
      </p>
    </section>

    <footer class="footer">
      <p>Consider joining a 12-Step group or speaking with a counselor to explore how this program can support your recovery journey.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'TwelveStepProcess'
};
</script>

<style scoped>
.twelve-step-process {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  padding: 20px;
  max-width: 800px;
  margin: auto;
}

.banner {
  padding: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.banner img {
  width: 100%;
  max-width: 700px;
  border-radius: 8px;
}

header {
  text-align: center;
  margin-bottom: 20px;
}

h1 {
  color: #2c3e50;
}

.section {
  margin-bottom: 20px;
}

.section h2 {
  color: #2c3e50;
  font-size: 1.5em;
  margin-top: 10px;
}

ol {
  margin-left: 20px;
  list-style-type: decimal;
}

.footer {
  margin-top: 20px;
  text-align: center;
  font-weight: bold;
  color: #555;
}
</style>
